import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Goal() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
   const VIDEO_ID = "joker20"
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);


  return (
     <CasinoPage
              casino={casinoData?.data}
              VIDEO_ID={VIDEO_ID}
              // VIDEO_ID={GAME_ID}
              GAME_ID={GAME_ID}
              // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
              //  VIDEO_ID={GAME_ID}
              // GAME_ID={GAME_ID}
              // shortName={"cards32a cards32b"}
              // gameName={"CARDS 32B"}
            >
    {/* <div className="center-main-container casino-page"> */}
    {/* <div className="center-container"> */}
      {/* <div className="casino-page-container ball-by-ball goal"> */}
        {/* <div className="casino-header"> */}
          {/* <span className="casino-name">
            Goal
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span> */}
          {/* <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>162250425213445</span>
            </small>
          </span> */}
        {/* </div> */}
        {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>162250425213445</span>
            </span>
          </div>
        </div> */}
        {/* <div className=""> */}
          {/* <div className="casino-video"> */}
            {/* <div className="video-box-container"> */}
              {/* <div className="casino-video-box"> */}
                {/* <iframe src="/mediaplayer/goal/290f62f1-bcfd-4bdd-a678-dae5ee457163?ip=122.160.119.41" /> */}
              {/* </div> */}
            {/* </div> */}
            {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">9</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">9</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
          {/* </div> */}
          <div className="casino-detail detail-page-container position-relative">
            <div className="game-market market-6 container-fluid container-fluid-5">
              <div className="market-title row row5">Who Will Goal Next?</div>
              <div className="market-header row row5">
                <div className="col-12 col-md-12 d-none d-md-block">
                  <div className="market-row">
                    <div className="market-nation-detail" />
                    <div className="market-odd-box back">
                      <b>Back</b>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4 d-md-none">
                  <div className="market-row">
                    <div className="market-nation-detail" />
                    <div className="market-odd-box back">
                      <b>Back</b>
                    </div>
                  </div>
                </div>
                <div className="fancy-min-max-box" />
              </div>
              <div className="market-body row">
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Cristiano Ronaldo
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">5.02</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Lionel Messi
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">5.59</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Robert Lewandowski
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">6.64</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">Neymar</span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">7.53</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Harry Kane
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">9.1</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Zlatan Ibrahimovic
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">11.86</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Romelu Lukaku
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">13.5</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Kylian Mbappe
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">15.06</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Erling Haaland
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">15.66</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          No Goal
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">35.59</span>
                          <span className="market-volume">30000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 25K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="game-market market-6 container-fluid container-fluid-5">
              <div className="market-title row row5">Method Of Next Goal</div>
              <div className="market-header row row5">
                <div className="col-12 col-md-12 d-none d-md-block">
                  <div className="market-row">
                    <div className="market-nation-detail" />
                    <div className="market-odd-box back">
                      <b>Back</b>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4 d-md-none">
                  <div className="market-row">
                    <div className="market-nation-detail" />
                    <div className="market-odd-box back">
                      <b>Back</b>
                    </div>
                  </div>
                </div>
                <div className="fancy-min-max-box" />
              </div>
              <div className="market-body row">
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Shot Goal
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">1.72</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Header Goal
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">4.5</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Penalty Goal
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">7.25</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          Free Kick Goal
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">10.88</span>
                          <span className="market-volume">100000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 50K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="fancy-market" data-title="OPEN">
                    <div className="market-row">
                      <div className="market-nation-detail">
                        <span className="market-nation-name pointer">
                          No Goal
                        </span>
                      </div>
                      <div className=" blb-box ">
                        <div className="market-odd-box back ">
                          <span className="market-odd">35.59</span>
                          <span className="market-volume">30000</span>
                        </div>
                      </div>
                      <div className="fancy-min-max-box">
                        <div className="fancy-min-max">
                          <span className="w-100 d-block">Min: 100.00</span>
                          <span className="w-100 d-block">Max: 25K</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-remark mt-1">
              <div className="remark-icon">
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/remark.png" />
              </div>
              <marquee scrollamount={3}>
                Results are based on stream&nbsp;only
              </marquee>
            </div>
            {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/goal">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
            </div> */}
          </div>
        {/* </div> */}
        <div className="d-none">
          <div className="table-responsive w-100">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      {/* </div> */}
    {/* </div> */}
    {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive w-100">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
  {/* </div> */}
  </CasinoPage>
  
  
  )
}
